
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_v(','),_c('g',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".667"}},[_c('path',{attrs:{"d":"M11.631 2.033L7.996.417A.969.969 0 006.72 1.699L8.379 5.38l3.888 3.89a.333.333 0 00.471 0l2.829-2.828a.333.333 0 000-.472z"}}),_c('path',{attrs:{"d":"M10.443 7.443l-7.834 7.833a1.333 1.333 0 01-1.885-1.885l7.833-7.834"}})])])
          )
        }
      }
    